import { IRootState } from '../../../store'
import { IRespiratoryOptionsState } from '../store/options.types'

export const getRespiratoryOptionsSelector = (state: IRootState): IRespiratoryOptionsState =>
  state.options.respiratoryOptions
